import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star--color",
  "use": "icon-star--color-usage",
  "viewBox": "0 0 64.758 61.982",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64.758 61.982\" id=\"icon-star--color\">\n<g id=\"icon-star--color_star--color\">\n\t<polygon style=\"fill:#F7CF80;\" points=\"48.776,39.806 51.639,61.982 31.825,51.618 11.616,61.192 15.353,39.146 0,22.885 \n\t\t22.123,19.626 32.844,0 42.78,20.033 64.758,24.164 \t\" />\n</g>\n<g id=\"icon-star--color_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol